module.exports = __webpack_public_path__ + "static/media/logo_BW.87d373cf.png";